// extracted by mini-css-extract-plugin
module.exports = {"container":"_k","disabled":"al","bgBlack":"bl","content":"cl","countdown":"dl","topCaption":"el","topHeading":"fl","heading":"gl","copy":"hl"};